import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { Button, Form, FormGroup, Label, Input, Row, Col, Table } from "reactstrap";
import CommonSelect from "../../../Basic/Select";
import { IconEditCustom, IconDelete, IconPlusCircleOutline } from "@sfx/icons";
import { getCountryCodeList } from "../../api";
import { userData } from "../data";
import { validatePhoneNumber } from "../../utils/formValidation";
import { scrollToSelect } from "../../utils/utils";
import { getTransFunc } from '../../../Basic/SFxLocalization';
import { cloneDeep } from 'lodash';
var phoneTypeList = [{
  name: 'SFxUserProfileCustom',
  value: "custom"
}, {
  name: 'SFxUserProfileMobilePhone',
  value: "mobile"
}, {
  name: 'SFxUserProfileOfficePhone',
  value: "office"
}, {
  name: 'SFxUserProfileBusinessPhone',
  value: "business"
}, {
  name: 'SFxUserProfileHomePhone',
  value: "home"
}, {
  name: 'SFxUserProfileFax',
  value: "fax"
}];
var Action = {
  ADD: 'add',
  EDIT: 'edit'
};
var prefix = "sfx-react-ui-user-profile";

var Profile = /*#__PURE__*/function (_React$Component) {
  _inherits(Profile, _React$Component);

  var _super = _createSuper(Profile);

  function Profile(props) {
    var _this;

    _classCallCheck(this, Profile);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.setState = function () {
        return;
      };
    });

    _defineProperty(_assertThisInitialized(_this), "checkProfile", function () {
      var _this$state$profileIn = _this.state.profileInfo,
          company = _this$state$profileIn.company,
          email = _this$state$profileIn.email,
          firstName = _this$state$profileIn.firstName,
          lastName = _this$state$profileIn.lastName;
      var profileValid = company.trim() && email.trim() && firstName.trim() && lastName.trim();
      return profileValid;
    });

    _defineProperty(_assertThisInitialized(_this), "reset", function () {
      _this.setState({
        showForm: false,
        addExtension: false,
        action: "",
        currentPhoneValid: false,
        phoneNumberValidMsg: "",
        currentPhone: {
          phoneType: {
            name: "",
            value: ""
          },
          customName: "",
          phoneCountryCode: {
            Code: "",
            GeonameId: ""
          },
          phoneNumber: "",
          extension: ""
        }
      }, function () {
        _this.props.setDisableState(false);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "savePhone", function () {
      var _this$state = _this.state,
          profileInfo = _this$state.profileInfo,
          phoneNumberList = _this$state.profileInfo.phoneNumberList,
          currentPhone = _this$state.currentPhone,
          action = _this$state.action;

      if (action === Action.ADD) {
        phoneNumberList.push(currentPhone);
        phoneNumberList.forEach(function (item, i) {
          if (!item._id) {
            item._id = i;
          }
        });

        _this.setState({
          profileInfo: _objectSpread(_objectSpread({}, profileInfo), {
            phoneNumberList: phoneNumberList
          })
        });
      } else {
        _this.setState({
          profileInfo: _objectSpread(_objectSpread({}, profileInfo), {
            phoneNumberList: phoneNumberList.map(function (item) {
              return item._id !== currentPhone._id ? item : currentPhone;
            })
          })
        });
      }

      _this.reset();
    });

    _defineProperty(_assertThisInitialized(_this), "editPhone", function (e, item) {
      _this.setState({
        showForm: true,
        currentPhone: item,
        action: Action.EDIT
      }, function () {
        _this.props.setDisableState(true);

        _this.scrollToAnchor();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "deletePhone", function (e, item) {
      var _this$state2 = _this.state,
          profileInfo = _this$state2.profileInfo,
          phoneNumberList = _this$state2.profileInfo.phoneNumberList;

      var newProfile = _objectSpread(_objectSpread({}, profileInfo), {
        phoneNumberList: phoneNumberList.filter(function (phoneNumber) {
          return phoneNumber._id !== item._id;
        })
      });

      _this.setState({
        profileInfo: newProfile
      });
    });

    _defineProperty(_assertThisInitialized(_this), "saveData", function () {
      var _this$state3 = _this.state,
          profileInfo = _this$state3.profileInfo,
          currentPhone = _this$state3.currentPhone;
      userData.profileInfo = profileInfo;
      userData.currentPhone = currentPhone;
    });

    _defineProperty(_assertThisInitialized(_this), "resetData", function () {
      _this.setState({
        profileInfo: {
          company: userData.profileInfo.company || "",
          email: userData.profileInfo.email || "",
          firstName: userData.profileInfo.firstName || "",
          lastName: userData.profileInfo.lastName || "",
          phoneNumberList: userData.profileInfo.phoneNumberList || []
        }
      });

      _this.reset();
    });

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (e) {
      var _e$target = e.target,
          name = _e$target.name,
          value = _e$target.value;
      var profileInfo = _this.state.profileInfo;

      _this.setState({
        profileInfo: _objectSpread(_objectSpread({}, profileInfo), _defineProperty({}, name, value))
      }, function () {
        var profileValid = _this.checkProfile();

        _this.props.setDisableState(!profileValid);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onPhoneNumberChange", function (e) {
      var trans = getTransFunc();
      var _e$target2 = e.target,
          name = _e$target2.name,
          value = _e$target2.value;
      var currentPhone = _this.state.currentPhone;

      _this.setState({
        currentPhone: _objectSpread(_objectSpread({}, currentPhone), _defineProperty({}, name, value))
      }, function () {
        if (name === "phoneNumber") {
          var validPhoneNumber = _this.validPhoneNumber();

          if (!validPhoneNumber.valid) {
            _this.setState({
              phoneNumberValidMsg: validPhoneNumber.message || trans('SFxUserProfilePhoneValidMsg')
            });
          } else {
            _this.setState({
              phoneNumberValidMsg: ""
            });
          }
        }

        _this.setButtonState();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "validPhoneNumber", function () {
      var res = validatePhoneNumber(_this.state.currentPhone.phoneNumber);
      return res;
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectChange", function (option, propName) {
      var currentPhone = _this.state.currentPhone;

      _this.setState({
        currentPhone: _objectSpread(_objectSpread({}, currentPhone), _defineProperty({}, propName, option))
      }, function () {
        _this.setButtonState();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCountryCodeChange", function (option) {
      if (!option) {
        return;
      }

      var currentPhone = _this.state.currentPhone;

      _this.setState({
        currentPhone: _objectSpread(_objectSpread({}, currentPhone), {}, {
          phoneCountryCode: {
            Code: option.Code,
            GeonameId: option.GeonameId
          }
        })
      }, function () {
        _this.setButtonState();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setButtonState", function () {
      var validPhoneType = _this.state.currentPhone.phoneType;
      var validCustomName = _this.state.currentPhone.phoneType.value === "custom" && _this.state.currentPhone.customName.trim() || _this.state.currentPhone.phoneType.value !== "custom";
      var validPhoneCountryCode = _this.state.currentPhone.phoneCountryCode && _this.state.currentPhone.phoneCountryCode.GeonameId;

      var validPhoneNumber = _this.validPhoneNumber();

      var currentPhoneValid = validPhoneType && validCustomName && validPhoneCountryCode && validPhoneNumber.valid;

      _this.setState({
        currentPhoneValid: Boolean(currentPhoneValid)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "scrollToAnchor", function () {
      var anchorElement = document.getElementById("profileAnchor");

      if (anchorElement) {
        anchorElement.scrollIntoView(false);
      }
    });

    _this.state = {
      showForm: false,
      addExtension: false,
      currentPhoneValid: false,
      countryCodeList: userData.staticSource && userData.staticSource.countryCodeList || [{
        Code: "93",
        FlagUrl: "https://www.geonames.org/flags/s/af.png",
        GeonameId: 1149361,
        Name: "Afghanistan"
      }, {
        Code: "355",
        FlagUrl: "https://www.geonames.org/flags/s/al.png",
        GeonameId: 783754,
        Name: "Albania"
      }],
      currentPhone: {
        customName: "",
        phoneType: {
          name: "",
          value: ""
        },
        phoneCountryCode: {
          GeonameId: "",
          Code: ""
        },
        phoneNumber: "",
        extension: ""
      },
      action: "",
      profileInfo: {
        company: userData.profileInfo.company || "",
        email: userData.profileInfo.email || "",
        firstName: userData.profileInfo.firstName || "",
        lastName: userData.profileInfo.lastName || "",
        phoneNumberList: cloneDeep(userData.profileInfo.phoneNumberList) || []
      },
      phoneNumberValidMsg: ""
    };
    return _this;
  }

  _createClass(Profile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.props.childEvent({
        saveData: this.saveData,
        resetData: this.resetData
      });

      if (!userData.staticSource.countryCodeList) {
        getCountryCodeList().then(function (res) {
          userData.staticSource.countryCodeList = res.data;

          _this2.setState({
            countryCodeList: res.data
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var trans = getTransFunc();
      var _this$state4 = this.state,
          countryCodeList = _this$state4.countryCodeList,
          _this$state4$profileI = _this$state4.profileInfo,
          company = _this$state4$profileI.company,
          email = _this$state4$profileI.email,
          firstName = _this$state4$profileI.firstName,
          lastName = _this$state4$profileI.lastName,
          phoneNumberList = _this$state4$profileI.phoneNumberList,
          action = _this$state4.action,
          showForm = _this$state4.showForm,
          addExtension = _this$state4.addExtension,
          currentPhoneValid = _this$state4.currentPhoneValid,
          currentPhone = _this$state4.currentPhone,
          _this$state4$currentP = _this$state4.currentPhone,
          phoneType = _this$state4$currentP.phoneType,
          customName = _this$state4$currentP.customName,
          phoneCountryCode = _this$state4$currentP.phoneCountryCode,
          phoneNumber = _this$state4$currentP.phoneNumber,
          extension = _this$state4$currentP.extension;
      return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, {
        form: true
      }, /*#__PURE__*/React.createElement(Col, {
        md: 6
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "company"
      }, trans('SFxUserProfileCompany')), /*#__PURE__*/React.createElement(Input, {
        type: "text",
        name: "company",
        id: "company",
        value: company,
        disabled: true,
        onChange: this.onInputChange
      }))), /*#__PURE__*/React.createElement(Col, {
        md: 6
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "email"
      }, trans('SFxUserProfileEmail')), /*#__PURE__*/React.createElement(Input, {
        type: "email",
        name: "email",
        id: "email",
        disabled: true,
        value: email,
        onChange: this.onInputChange
      })))), /*#__PURE__*/React.createElement(Row, {
        form: true
      }, /*#__PURE__*/React.createElement(Col, {
        md: 6
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "firstName"
      }, trans('SFxUserProfileFirstName'), !firstName.trim() && /*#__PURE__*/React.createElement("span", {
        className: "required"
      }, "*")), /*#__PURE__*/React.createElement(Input, {
        type: "text",
        name: "firstName",
        id: "firstName",
        value: firstName,
        onChange: this.onInputChange,
        maxLength: 50
      }))), /*#__PURE__*/React.createElement(Col, {
        md: 6
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "lastName"
      }, trans('SFxUserProfileLastName'), !lastName.trim() && /*#__PURE__*/React.createElement("span", {
        className: "required"
      }, "*")), /*#__PURE__*/React.createElement(Input, {
        type: "text",
        name: "lastName",
        id: "lastName",
        value: lastName,
        onChange: this.onInputChange,
        maxLength: 50
      })))), /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
        colSpan: 4,
        style: {
          paddingLeft: 0
        }
      }, trans('SFxUserProfilePhoneNumbers')))), /*#__PURE__*/React.createElement("tbody", null, phoneNumberList.map(function (item, index) {
        return /*#__PURE__*/React.createElement("tr", {
          key: index,
          className: item._id === currentPhone._id && action === Action.EDIT ? "activeItem" : ""
        }, /*#__PURE__*/React.createElement("td", {
          scope: "row"
        }, item.phoneType.value === "custom" ? item.customName : trans(item.phoneType.name)), /*#__PURE__*/React.createElement("td", null, "".concat(item.phoneCountryCode.Code && "+").concat(item.phoneCountryCode.Code, " ").concat(item.phoneNumber, " ").concat(item.extension && "Ext. ".concat(item.extension))), /*#__PURE__*/React.createElement("td", {
          style: {
            textAlign: "right"
          }
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            display: "flex",
            justifyContent: "flex-end"
          }
        }, /*#__PURE__*/React.createElement("span", {
          onClick: function onClick(e) {
            return _this3.editPhone(e, item);
          }
        }, /*#__PURE__*/React.createElement(IconEditCustom, {
          size: "18",
          className: "".concat(prefix, "-icon-wrap")
        })), !item.main && /*#__PURE__*/React.createElement("span", {
          onClick: function onClick(e) {
            return _this3.deletePhone(e, item);
          }
        }, /*#__PURE__*/React.createElement(IconDelete, {
          size: "18",
          className: "".concat(prefix, "-icon-wrap")
        })))));
      }))), /*#__PURE__*/React.createElement("div", {
        id: "profileAnchor",
        style: {
          paddingBottom: "16px"
        }
      }, !showForm && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-icon-wrap"),
        onClick: function onClick() {
          _this3.setState({
            showForm: true,
            action: Action.ADD
          }, function () {
            _this3.scrollToAnchor();
          });

          _this3.props.setDisableState(true);
        }
      }, /*#__PURE__*/React.createElement(IconPlusCircleOutline, {
        size: "18"
      }), " \xA0  ", trans('SFxUserProfileAddPhoneNumbers')), /*#__PURE__*/React.createElement(Row, {
        form: true
      }, showForm && /*#__PURE__*/React.createElement(Col, {
        md: 6
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "exampleSelect"
      }, trans('SFxUserProfilePhoneType'), !phoneType && /*#__PURE__*/React.createElement("span", {
        className: "required"
      }, "*")), /*#__PURE__*/React.createElement(CommonSelect, {
        onMenuOpen: function onMenuOpen() {
          scrollToSelect();
        },
        renderOption: function renderOption(option) {
          return {
            label: trans(option.name),
            value: option.value
          };
        },
        value: phoneType,
        options: phoneTypeList,
        onChange: function onChange(option) {
          _this3.onSelectChange(option, "phoneType");
        }
      }))), phoneType.value && /*#__PURE__*/React.createElement(React.Fragment, null, phoneType.value === "custom" && /*#__PURE__*/React.createElement(Col, {
        md: "6"
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "customName"
      }, trans('SFxUserProfileCustomName'), !customName.trim() && /*#__PURE__*/React.createElement("span", {
        className: "required"
      }, "*")), /*#__PURE__*/React.createElement(Input, {
        type: "text",
        name: "customName",
        value: customName,
        onChange: this.onPhoneNumberChange
      }))), /*#__PURE__*/React.createElement(Col, {
        md: 6
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "exampleSelect"
      }, trans('SFxUserProfilePhoneCountryCode'), !phoneCountryCode && /*#__PURE__*/React.createElement("span", {
        className: "required"
      }, "*")), /*#__PURE__*/React.createElement(CommonSelect // menuPlacement={"top"}
      , {
        onMenuOpen: function onMenuOpen() {
          scrollToSelect();
        },
        renderOption: function renderOption(i) {
          return {
            label: i.GeonameId && "(+".concat(i.Code, ") ").concat(i.Name),
            value: i.GeonameId
          };
        },
        value: phoneCountryCode,
        showFlag: true,
        options: countryCodeList,
        onChange: function onChange(option) {
          return _this3.onCountryCodeChange(option);
        }
      }))), /*#__PURE__*/React.createElement(Col, {
        md: 6
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "phoneNumber"
      }, trans('SFxUserProfilePhoneNumber'), !phoneNumber.trim() && /*#__PURE__*/React.createElement("span", {
        className: "required"
      }, "*")), /*#__PURE__*/React.createElement(Input, {
        type: "text",
        name: "phoneNumber",
        id: "phoneNumber",
        value: phoneNumber,
        onChange: this.onPhoneNumberChange
      }), /*#__PURE__*/React.createElement("p", {
        className: "formValidErrorTip"
      }, this.state.phoneNumberValidMsg))), /*#__PURE__*/React.createElement(Col, {
        md: 6
      }, addExtension || extension ? /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        for: "extension"
      }, "   ", trans('SFxUserProfileExtension')), /*#__PURE__*/React.createElement(Input, {
        type: "text",
        name: "extension",
        id: "extension",
        value: extension,
        onChange: this.onPhoneNumberChange
      })) : /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "".concat(phoneType.value === 'custom' ? '' : '40px')
        },
        onClick: function onClick() {
          _this3.setState({
            addExtension: true
          }, function () {
            _this3.scrollToAnchor();
          });
        }
      }, /*#__PURE__*/React.createElement(IconPlusCircleOutline, {
        size: "18"
      }), "\xA0  ", trans('SFxUserProfileAddExtension'))))), showForm && /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "flex-end"
        }
      }, /*#__PURE__*/React.createElement(Button, {
        size: "sm",
        style: {
          marginRight: 10
        },
        onClick: this.reset
      }, trans('SFxUserProfileCancel')), /*#__PURE__*/React.createElement(Button, {
        disabled: !currentPhoneValid,
        size: "sm",
        color: "primary",
        onClick: this.savePhone
      }, action, " ", trans('SFxUserProfilePhoneNumber')))));
    }
  }]);

  return Profile;
}(React.Component);

export { Profile as default };